import { clearOfflineMarker } from "./offlineMarker";

export const TIDE_TOKEN_KEY = "id_token";
export const AKVA_TOKEN_KEY = "token";
export const REFRESH_TOKEN_KEY = "refresh_token";

// Who the bridged token belongs to, read without amplify. A refusal at boot
// lands before the user store is filled and after amplify has begun clearing
// its own tokens, and this copy is the only record of the identity left.
export function syncedTokenSub(): string | null {
  try {
    const payload = localStorage.getItem(TIDE_TOKEN_KEY)?.split(".")[1];
    if (!payload) return null;
    const json = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
    const sub = (JSON.parse(json) as { sub?: unknown }).sub;
    return typeof sub === "string" && sub ? sub : null;
  } catch {
    return null;
  }
}

// Also drops the offline marker: every caller of this is a session ending or
// a new one starting, and a marker that outlives its session tells the other
// screens to stay signed in after a sign-out.
export function clearSyncedTokens(): void {
  clearOfflineMarker();
  try {
    localStorage.removeItem(TIDE_TOKEN_KEY);
    localStorage.removeItem(AKVA_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  } catch {
    /* localStorage unavailable */
  }
}
